var render = function render(_c,_vm){return _c('div',{staticClass:"card-many-to-many__list-wrapper"},[_c('div',{staticClass:"card-many-to-many__list"},_vm._l((_vm.props.value),function(item){return _c('div',{key:item.id,staticClass:"card-many-to-many__item card-multiple-select-option",class:'background-color--' + item.color},[_c('span',{staticClass:"card-many-to-many__name"},[_vm._v(_vm._s(item.value))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }